import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Xls: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[34px] h-[40px]', className)}
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="40"
    viewBox="0 0 34 40"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 4C0 2.93913 0.421427 1.92172 1.17157 1.17157C1.92172 0.421427 2.93913 0 4 0H23.333L33.333 10V36C33.333 37.0609 32.9116 38.0783 32.1614 38.8284C31.4113 39.5786 30.3939 40 29.333 40H4C2.93913 40 1.92172 39.5786 1.17157 38.8284C0.421427 38.0783 0 37.0609 0 36V4Z"
      fill="url(#paint0_linear_1492_2559)"
    />
    <path
      d="M26.6918 9.9901C25.8147 9.9901 24.9735 9.64169 24.3534 9.02151C23.7332 8.40132 23.3848 7.56017 23.3848 6.6831V0.0581055L33.3308 9.9901H26.6908H26.6918Z"
      fill="#16613F"
    />
    <path
      d="M13.175 34.31L11.791 36.333H12.975L13.778 35.121L14.581 36.333H15.787L14.366 34.287L15.63 32.487H14.462L13.792 33.491L13.116 32.487H11.91L13.174 34.31H13.175ZM16.219 31.021V36.333H17.276V31.021H16.219ZM18.926 35.083H17.922C17.932 35.341 17.988 35.557 18.092 35.731C18.202 35.899 18.338 36.036 18.502 36.14C18.67 36.244 18.862 36.318 19.075 36.363C19.5018 36.4514 19.9422 36.4514 20.369 36.363C20.5698 36.3282 20.762 36.2548 20.935 36.147C21.098 36.043 21.23 35.907 21.329 35.738C21.433 35.565 21.485 35.351 21.485 35.098C21.4899 34.951 21.4577 34.8051 21.3912 34.6738C21.3248 34.5425 21.2264 34.4301 21.105 34.347C20.9854 34.2597 20.8528 34.1919 20.712 34.146C20.5655 34.0955 20.4162 34.0531 20.265 34.019C20.1191 33.9851 19.9728 33.9531 19.826 33.923C19.6956 33.8965 19.5665 33.8641 19.439 33.826C19.3415 33.7928 19.2507 33.7423 19.171 33.677C19.1375 33.649 19.1107 33.6137 19.0927 33.5739C19.0747 33.5341 19.0659 33.4907 19.067 33.447C19.067 33.367 19.087 33.305 19.127 33.261C19.1644 33.213 19.2128 33.1746 19.268 33.149C19.3298 33.1235 19.3953 33.1083 19.462 33.104C19.531 33.094 19.596 33.09 19.655 33.09C19.843 33.09 20.007 33.127 20.146 33.201C20.285 33.271 20.362 33.407 20.376 33.611H21.381C21.3716 33.4161 21.3154 33.2263 21.217 33.0578C21.1187 32.8893 20.9811 32.747 20.816 32.643C20.6529 32.5455 20.4738 32.4778 20.287 32.443C19.8866 32.3631 19.4744 32.3631 19.074 32.443C18.876 32.477 18.698 32.541 18.539 32.636C18.38 32.725 18.251 32.849 18.152 33.008C18.058 33.166 18.011 33.37 18.011 33.618C18.011 33.786 18.046 33.93 18.115 34.049C18.185 34.163 18.276 34.26 18.39 34.339C18.504 34.414 18.633 34.476 18.777 34.525C18.926 34.57 19.077 34.61 19.231 34.645C19.608 34.724 19.901 34.803 20.109 34.882C20.322 34.962 20.429 35.081 20.429 35.24C20.4318 35.3244 20.4084 35.4075 20.362 35.478C20.3158 35.5386 20.2576 35.589 20.191 35.626C20.0514 35.6999 19.8949 35.7361 19.737 35.731C19.633 35.731 19.531 35.718 19.432 35.693C19.3421 35.6703 19.2566 35.6328 19.179 35.582C19.1047 35.5275 19.0416 35.4593 18.993 35.381C18.9465 35.2887 18.9235 35.1863 18.926 35.083Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.33203 14.167H13.332V11.667H8.33203V14.167ZM13.332 18.333H8.33203V15.833H13.332V18.333ZM13.332 22.5H8.33203V20H13.332V22.5ZM24.999 18.333H14.999V15.833H24.999V18.333ZM14.999 22.5H24.999V20H14.999V22.5ZM14.999 14.167V11.667H24.999V14.167H14.999Z"
      fill="white"
      fillOpacity="0.4"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1492_2559"
        x1="0"
        y1="0"
        x2="0"
        y2="40"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#529778" />
        <stop offset="1" stopColor="#1A754C" />
      </linearGradient>
    </defs>
  </svg>
);

export default Xls;
